import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const dialog: CSSProperties = {
  padding: 32,
  overflow: "auto",
};

export const buttons: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  padding: 14,
  borderTop: `1px solid ${greys.borderGrey}`,
};

export const loading: CSSProperties = {
  width: 536,
  height: 300,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const styles = {
  dialog,
  buttons,
  loading,
};
